import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useContext } from 'react';
import { AutocompleteGroupsAndAssetsContext } from './NRAutocompleteGroupsAndAssetsContextWrapper';

function AssetAndGroupsButtons({ onRequestFocusFilter, firstToggleButtonRef, lastToggleButtonRef }) {
  const theme = useTheme();
  const { assetsSelected, setAssetsSelected } = useContext(AutocompleteGroupsAndAssetsContext);

  const handleSetAssetsSelected = () => {
    setAssetsSelected(!assetsSelected);
  };

  return (
    <Box
      data-nr-asset-group-header
      sx={{ height: 52, borderBottom: `1px solid ${theme.palette.divider}` }}
      py={1}
      px={2}
      onKeyDownCapture={e => {
        if (!onRequestFocusFilter) return;
        // MenuList walks nextElementSibling, so ArrowDown from the two buttons never reaches
        // the filter. Capture and move into the filter.
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          e.stopPropagation();
          onRequestFocusFilter();
        }
      }}
    >
      <ButtonGroup variant="outlined" aria-label="outlined primary button group" sx={{ width: '100%' }}>
        <Button
          ref={firstToggleButtonRef}
          sx={{ textTransform: 'none', width: '50%' }}
          variant={!!assetsSelected ? 'contained' : 'outlined'}
          color="secondary"
          onClick={handleSetAssetsSelected}
        >
          <Typography>Assets</Typography>
        </Button>
        <Button
          ref={lastToggleButtonRef}
          sx={{ textTransform: 'none', width: '50%' }}
          variant={!assetsSelected ? 'contained' : 'outlined'}
          color="secondary"
          onClick={handleSetAssetsSelected}
        >
          <Typography>Groups</Typography>
        </Button>
      </ButtonGroup>
    </Box>
  );
}

export default AssetAndGroupsButtons;
